import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/force-calculator',
  component: () => import('../../routes/ForceCalculator.svelte'),
  card: {
    id: 'force-calculator',
    title: 'Force Calculator',
    description: 'Calculate force, mass, or acceleration using Newton\'s Second Law (F = ma). Also computes kinetic energy, potential energy, work, and power.',
    icon: 'sports_martial_arts',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/force-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Force Calculator – Calculate F = ma (Newton\'s Second Law)',
    description: 'Free force calculator using Newton\'s Second Law. Calculate force, mass, or acceleration instantly. Also computes kinetic energy, potential energy, work, and power with step-by-step formulas.',
  },
};

export default meta;
